module.exports = __webpack_public_path__ + "static/media/mail.a982bab6.svg";